export type NotificationType = 'success' | 'info' | 'warning' | 'error';

export interface StyledPageProps {
  $testTimeVisible: boolean;
}

export const formatTestDate = (endedAt?: string): string => {
  if (!endedAt) return 'N/A';
  return new Date(endedAt).toLocaleDateString('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
};

export const SKELETON_MOCK_DATA = [
  {
    groupFlowSensorId: '1',
    flowSensorName: 'Mock',
    compressors: [{ deviceId: 1 }, { deviceId: 2 }, { deviceId: 3 }, { deviceId: 4 }, { deviceId: 5 }],
    FLOW: { status: 'mock', comment: 'mock' },
  },
];
